import { toast } from "react-toastify";
import useUserStore from "../store/user";

export const handleToken = (message: string) => {
  const { clearUser } = useUserStore.getState();
  if (message === "Token expirado" || message === "Token informado inválido") {
    clearUser();
    localStorage.removeItem("user-storage");
    window.location.href = "/login";
    toast.error("Sessão expirada, faça login novamente.");
  }
};
